import { render, staticRenderFns } from "./registerDc.vue?vue&type=template&id=a4cc2718&scoped=true"
import script from "./registerDc.vue?vue&type=script&lang=js"
export * from "./registerDc.vue?vue&type=script&lang=js"
import style0 from "./registerDc.vue?vue&type=style&index=0&id=a4cc2718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cc2718",
  null
  
)

export default component.exports